import { hooks, mui, React, ts, ui } from '_core';

import { DraftParams } from './types';
import BenchmarkTargetSelector from '../../common/forms/benchmark-target-selector';

type FormProps = {
  params: DraftParams;
  setParams: (_p: DraftParams) => void;
  context?: ts.types.backtest.BacktestAnaylsisContext;
};

const Form = ({ params, setParams, context }: FormProps) => {
  const [selectedHistories, setSelectedHistories] = React.useState(
    params.histories || ([] as ts.enums.HISTORY_ENUM_EXTENDED[])
  );

  const [benchmark, setBenchmark] = React.useState(params.benchmark || null);
  const [withBenchmark, setWithBenchmark] = React.useState(params.with_benchmark || false);

  const uiStyles = hooks.useUiStyles();

  React.useEffect(() => {
    const data = {
      ...params,
      histories: selectedHistories,
      with_benchmark: withBenchmark,
    };
    if (withBenchmark) data.benchmark = benchmark;
    else delete data.benchmark;

    setParams(data);
  }, [selectedHistories, withBenchmark, benchmark]);

  return (
    <mui.core.Box sx={uiStyles.widgetEditMode}>
      <mui.core.Box mt={2}>
        <ui.WidgetHistories<true>
          multiple
          context={context}
          value={selectedHistories}
          setValue={setSelectedHistories}
        />
      </mui.core.Box>

      <BenchmarkTargetSelector
        benchmark={benchmark}
        setBenchmark={setBenchmark}
        withBenchmark={withBenchmark}
        setWithBenchmark={setWithBenchmark}
        onlyReturnsLabel={params.statistics_type === 'risk' ? 'Risk' : 'Returns'}
      />
    </mui.core.Box>
  );
};

export default Form;
